import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Store from "@material-ui/icons/Store";
import Accessibility from "@material-ui/icons/Accessibility";
import GridItem from "../../Components/Grid/GridItem";
import GridContainer from "../../Components/Grid/GridContainer.js";
import Card from "../../Components/Card/Card.js";
import CardHeader from "../../Components/Card/CardHeader.js";
import CardIcon from "../../Components/Card/CardIcon.js";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { PageStatus } from "../../enums";
import { SurveysAPI } from "../../API";
import { connect } from "react-redux";
import { Alert, Container, Spinner } from "react-bootstrap";
import { Show } from "../../Layout";
import country from "config/countryConfig";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(styles);

function Dashboard({ ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(PageStatus.None);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      setStatus(PageStatus.Loading);
      try {
        const response = await SurveysAPI.userRespondentDashboardWeb(rest.userId, rest.language);
        if (isMounted) {
          if (response) {
            setData(response);
            setStatus(PageStatus.Loaded);
          } else {
             setStatus(PageStatus.Loaded); // Or error?
          }
        }
      } catch (error) {
        if (isMounted) {
          setStatus(PageStatus.Error);
          setError(error.message);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [rest.language]);

  const renderProfileStatus = () => {
    console.log("DBG country object:", country);
    console.log("DBG profile points:", country.profileCompletionPoints);
    console.log("DBG referral points:", country.referralMonthlyPoints);
    const goToProfile = () => rest.history.push('/panelist/profile-overview');
    const goToRewards = () => rest.history.push('/panelist/my-rewards');
    const goToReferrals = () => rest.history.push('/panelist/my-referrals');

    const referFriendsParagraph = (
      <p style={{ color: 'red', paddingBottom: '0px', marginBottom: '0px' }}>
        {t('dashboard.profileStatus.referFriendsPrefix')}{' '}
        <span style={{ fontWeight: 'bold', color: 'red' }}>
          {t('dashboard.profileStatus.referralRewardSuffix', { referralPoints: country.referralMonthlyPoints })}
        </span>
        <button
          className="bg-transparent mx-1 flicker-text"
          onClick={goToReferrals}
        >
          <span style={{ color: 'blue' }}>{t('dashboard.profileStatus.goToPrefix')}</span>
          <span style={{ fontWeight: 'bold', color: 'blue' }}>{t('dashboard.profileStatus.myReferralsLink')}</span>
        </button>{""}
      </p>
    );

    const surveysMatchedParagraph = (
      <p style={{ color: 'red', paddingBottom: '0px', marginBottom: '0px' }}>
        {t('dashboard.profileStatus.surveysMatchedRewards')}
      </p>
    );

    if (!data || data.overallAttemptedPercentage.points > 0) {
      return (
        <>
          <p style={{ color: 'red', paddingBottom: '0px', marginBottom: '0px' }}>
            {t('dashboard.profileStatus.completeProfilePrefix')}{' '}
            <span style={{ fontWeight: 'bold', color: 'red' }}>
            {t('dashboard.profileStatus.earnPointsInstantly', { points: rest.loginRewardType === 'ChaiPoint' ? 100 : (country.profileCompletionPoints ?? 50) })}
            </span>
            <button
              className="bg-transparent mx-1 flicker-text"
              onClick={goToProfile}
              style={{ fontWeight: 'bold', color: 'blue' }}
            >
              {t('dashboard.profileStatus.clickHere')}
            </button>{""}
          </p>
          {referFriendsParagraph}
          {surveysMatchedParagraph}
        </>
      );
    } else {
      return (
        <>
          <p style={{ color: 'green' }}>
            {t('dashboard.profileStatus.profileCompletedPrefix')}{""}
            <button
              className="bg-transparent mx-1"
              onClick={goToRewards}
              style={{ fontWeight: 'bold', color: 'blue' }}
            >
              {t('dashboard.profileStatus.clickHere')}
            </button>{""}
            {' '}{t('dashboard.profileStatus.toViewReward')}
          </p>
        </>
      );
    }
  }

  const cardHeight = {
    height: '120px'
  }
  return (
    <div>
      {/*<ReactStars count={5} value={5} size={24} activeColor="#ffd700"/>*/}


      <Show when={status === PageStatus.Loaded}>
        <div className="jumbotron bg-white p-3 border shadow-sm">
          {/* let ignore this code snippet 
          {data ? data.overallAttemptedPercentage.points > 0 ?
            rest.language === 'hi' ?
              <p style={{ color: 'red' }}>
                आपकी प्रोफ़ाइल लंबित है, कृपया 50 पॉइंट प्राप्त करने के लिए इसे पूरा करें। प्रोफ़ाइल भरना शुरू करने के लिए
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/profile-overview')}
                  style={{ fontWeight: 'bold', color: 'red' }}>यहां क्लिक करें</button></strong>
              </p>
              :
              <p style={{ color: 'red' }}>
                Your profile is pending, please complete it to get {country.profileCompletionPoints} Points.
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/profile-overview')}
                  style={{ fontWeight: 'bold', color: 'red' }}>Click Here</button></strong>
                to start filling profile
              </p>
            :
            rest.language === 'hi' ?
              <p style={{ color: 'green' }}>
                आपकी प्रोफ़ाइल पूरी हो गई है, अपना इनाम देखने के लिए
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/my-rewards')}
                  style={{ fontWeight: 'bold', color: 'green' }}>यहां क्लिक करें</button></strong>
              </p>
              :
              <p style={{ color: 'green' }}>
                Your profile is completed,
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/my-rewards')}
                  style={{ fontWeight: 'bold', color: 'green' }}>click here</button></strong>
                to view your reward.
              </p>

            :
            rest.language === 'hi' ?
              <p style={{ color: 'red' }}>
                आपकी प्रोफ़ाइल लंबित है, कृपया 50 पॉइंट प्राप्त करने के लिए इसे पूरा करें। प्रोफ़ाइल भरना शुरू करने के लिए
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/profile-overview')}
                  style={{ fontWeight: 'bold', color: 'red' }}>यहां क्लिक करें</button></strong>
              </p>
              :
              <p style={{ color: 'red' }}>
                Your profile is pending, please complete it to get {country.profileCompletionPoints} Points.
                <strong>{""}<button className="bg-transparent mr-1 ml-1" onClick={() => rest.history.push('/panelist/profile-overview')}
                  style={{ fontWeight: 'bold', color: 'red' }}>Click Here</button></strong>
                to start filling profile.
              </p>
          } */}
          {renderProfileStatus()}
        </div>
      </Show>

      <GridContainer>

        <Show when={status === PageStatus.Loading}>
          <Container className="d-flex justify-content-center mt-5">
            <Spinner animation="border" variant="primary" />
          </Container>
        </Show>

        <Alert
          variant="danger"
          show={status === PageStatus.Error}
        >
          {error}
        </Alert>

        <Show when={status === PageStatus.Loaded && !!data}>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalSurveys.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalSurveys.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="warning" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p className={classes.cardCategory}>{data?.completeSurveys.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.completeSurveys.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="success" stats icon>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{data?.incompleteSurveys.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.incompleteSurveys.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="danger" stats icon>
                <CardIcon color="info">
                  <Accessibility />
                </CardIcon>
                <p className={classes.cardCategory}>{data?.notStartedSurveys.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.notStartedSurveys.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{data?.overallAttemptedPercentage.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.overallAttemptedPercentage.points || 0}<small>%</small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalLeft.name || 0}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalLeft.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalReferralsApproved.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalReferralsApproved.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Accessibility />
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalReferralsPoints.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalReferralsPoints.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalReferralsStatistics.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalReferralsStatistics.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card style={cardHeight}>
              <CardHeader color="info" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p className={classes.cardCategory}>{data?.totalRewardPoints.name || ''}</p>
                <h3 className={classes.cardTitle}>
                  {data?.totalRewardPoints.points || 0}<small></small>
                </h3>
              </CardHeader>
            </Card>
          </GridItem>
        </Show>
      </GridContainer>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.adminUser.adminUser.userId,
    role: state.adminUser.adminUser.role,
    language: state.adminUser.adminUser.language,
    loginRewardType: state.adminUser.adminUser.loginRewardType,
  };
}

export default connect(mapStateToProps)(Dashboard);
